'use client';

import { useRef } from 'react';
import { Menu, BodyDefault, useThemeMode } from '@terra/ui-design-system';
import { Box, HStack } from '@terra/ui-styled-system';
import { Tick01Icon, ArrowRight01Icon } from '@terra/ui-icons';
import { useTranslations } from 'next-intl';
import { SidebarSubmenu } from '../SidebarSubmenu';
import { THEME_OPTIONS } from './themeOptions';

export function AppearanceSubmenu() {
  const t = useTranslations('layout');
  const { preference, toggleMode } = useThemeMode();
  const triggerRef = useRef<HTMLDivElement>(null);

  return (
    <SidebarSubmenu
      triggerRef={triggerRef}
      trigger={
        <Menu.TriggerItem ref={triggerRef} p="2">
          <HStack gap="2" w="full" alignItems="center">
            <BodyDefault flexGrow={1}>{t('appearance')}</BodyDefault>
            <Box
              w="14px"
              h="14px"
              flexShrink={0}
              display="flex"
              alignItems="center"
              justifyContent="center"
              color="fg.neutral.default"
            >
              <Menu.Indicator>
                <ArrowRight01Icon size={14} />
              </Menu.Indicator>
            </Box>
          </HStack>
        </Menu.TriggerItem>
      }
    >
      <Menu.ItemGroup gap="0">
        {THEME_OPTIONS.map(({ value, labelKey, icon: Icon }) => (
          <Menu.Item
            key={value}
            value={value}
            p="2"
            onClick={() => toggleMode(value)}
          >
            <HStack gap="2" w="full" alignItems="center">
              <Box
                w="14px"
                h="14px"
                flexShrink={0}
                display="flex"
                alignItems="center"
                color="fg.neutral.default"
              >
                <Icon size={14} />
              </Box>
              <BodyDefault flexGrow={1}>{t(labelKey)}</BodyDefault>
              <Box
                w="14px"
                h="14px"
                flexShrink={0}
                display="flex"
                alignItems="center"
              >
                {preference === value ? <Tick01Icon size={14} /> : null}
              </Box>
            </HStack>
          </Menu.Item>
        ))}
      </Menu.ItemGroup>
    </SidebarSubmenu>
  );
}
